import { CategoryCompactType } from 'routes/Integrations/helpers/types'
import { useIntegrationCategories } from 'routes/Integrations/context/IntegrationCategoriesContext'
import { IntegrationsCategoriesGridItem } from './IntegrationsCategoriesGridItem'
import classes from './IntegrationsCategoriesGrid.module.scss'

export const IntegrationsCategoriesGrid = ({
  filteredCategories,
  loading,
  value,
  onChange,
}: {
  filteredCategories: CategoryCompactType[]
  loading: boolean
  value?: string
  onChange: (category: string) => void
}) => {
  const categories = useIntegrationCategories()

  const selectedCategory = value

  return (
    <div className={classes.wrapper}>
      <ul className={classes.list}>
        {categories.map((item, idx) => (
          <IntegrationsCategoriesGridItem
            key={idx}
            item={item}
            filteredCategories={filteredCategories}
            loading={loading}
            selectedCategory={selectedCategory}
            onChange={onChange}
          />
        ))}
      </ul>
    </div>
  )
}
